import React, {Component} from 'react';
import queryString from 'query-string';

import AccountDetails from "./AccountDetails";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";

class Account extends Component {

    state = {
        mode: 'details'
    };

    componentWillMount(){
        const parsedParams = queryString.parse(window.location.search);
        if(parsedParams.mode){
            this.setState({
                mode: parsedParams.mode
            });
        }
    }

    render = () => {

        const {mode} = this.state;

        const accountDetails = (mode === 'details' && <AccountDetails />);

        const forgotPassword = (mode === 'forgotPassword' && <ForgotPassword />);

        const resetPassword = (mode === 'resetPassword' && <ResetPassword />);

        return (
            <div className="account_page__wrap">
                {accountDetails}
                {forgotPassword}
                {resetPassword}
            </div>
        )
    }
}

export default Account;


// WEBPACK FOOTER //
// ./src/components/Account/Account.js